import { appConfig } from '@/shared/config/app-config'

// Globals published by the embed.js bootstrap served from
// support-live-chat (see operations-monorepo/apps/support-live-chat).
// Their names come from the config; both may be missing because the script
// may not have loaded yet at any given moment.

export interface SupportWidgetConfig {
  getAuthToken?: () => Promise<string | null>
  isEligible?: () => boolean
  onError?: (err: Error) => void
}

export interface SupportWidget {
  readonly active: boolean
  subscribe: (cb: (active: boolean) => void) => () => void
}

type SupportWindow = Window & Record<string, unknown>

export function setSupportWidgetConfig(config: SupportWidgetConfig): void {
  ;(window as unknown as SupportWindow)[appConfig.supportGlobals.config] =
    config
}

export function supportWidget(): SupportWidget | undefined {
  return (window as unknown as SupportWindow)[
    appConfig.supportGlobals.widget
  ] as SupportWidget | undefined
}
